import React from 'react';
import styled from 'styled-components';
import Organization from './organization';

const OrganizationsWrap = styled.div`
  padding-top: 24px;
  grid-column-gap: 0rem;
  grid-row-gap: 0rem;
  grid-template-rows: auto auto;
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Organizations = ({ data }) => {
  return (
    <OrganizationsWrap>
      {data.map((univ) => (
        <Organization key={univ.url} url={univ.url} imgUrl={univ.imageUrl} />
      ))}
    </OrganizationsWrap>
  );
};

export default Organizations;
